module.exports = __webpack_public_path__ + "static/media/team_02.705e501f.jpg";